module.exports = __webpack_public_path__ + "img/soligenix.f1251f35.png";